import { render, staticRenderFns } from "./FrequencyCreate.vue?vue&type=template&id=8b138a8c&scoped=true"
import script from "./FrequencyCreate.vue?vue&type=script&lang=js"
export * from "./FrequencyCreate.vue?vue&type=script&lang=js"
import style0 from "./FrequencyCreate.vue?vue&type=style&index=0&id=8b138a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b138a8c",
  null
  
)

export default component.exports